"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSuperUser = exports.SENSITIVE_URL_PARAMS = exports.RESET_PASSWORD_TOKEN_URL_PARAM = exports.CONFIRMATION_TOKEN_URL_PARAM = exports.RESET_PASSWORD_ENCRYPTED_EMAIL_URL_PARAM = exports.ENCRYPTED_EMAIL_URL_PARAM = exports.REFERRAL_URL_PARAM = exports.ADMIN_ROLES = void 0;
var ADMIN_ROLES;
(function (ADMIN_ROLES) {
    ADMIN_ROLES["superAdmin"] = "super-admin";
    ADMIN_ROLES["supervisor"] = "supervisor";
    ADMIN_ROLES["manager"] = "manager";
    ADMIN_ROLES["producer"] = "producer";
})(ADMIN_ROLES = exports.ADMIN_ROLES || (exports.ADMIN_ROLES = {}));
exports.REFERRAL_URL_PARAM = 'ref';
exports.ENCRYPTED_EMAIL_URL_PARAM = 'authId';
exports.RESET_PASSWORD_ENCRYPTED_EMAIL_URL_PARAM = 'lkdiuqo';
exports.CONFIRMATION_TOKEN_URL_PARAM = 'confirmationToken';
exports.RESET_PASSWORD_TOKEN_URL_PARAM = 'resetPasswordToken';
exports.SENSITIVE_URL_PARAMS = [
    exports.REFERRAL_URL_PARAM,
    exports.ENCRYPTED_EMAIL_URL_PARAM,
    exports.RESET_PASSWORD_ENCRYPTED_EMAIL_URL_PARAM,
    exports.CONFIRMATION_TOKEN_URL_PARAM,
    exports.RESET_PASSWORD_TOKEN_URL_PARAM,
];
function isSuperUser(adminRole) {
    return adminRole === ADMIN_ROLES.superAdmin || adminRole === ADMIN_ROLES.supervisor;
}
exports.isSuperUser = isSuperUser;
//# sourceMappingURL=index.js.map